/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import useBreakpoints from '../../../../../common/hooks/useBreakpoints';
import Icons from '../../../../../common/widgets/Icons';
import { CustomerInfoContext } from '../../../contexts/CustomerInfoContext';
import { resources } from '../../../resources/resources';
import CategoriesNavArea from './categoriesNavItems/CategoriesNavArea';
import Account from './menuItems/AccountMenuItem';
import Admin from './menuItems/AdminMenuItem';
import Favorite from './menuItems/FavoriteMenuItem';
import Help from './menuItems/HelpMenuItem';
import Language from './menuItems/LanguageMenuItem';
import WalletBox from './menuItems/WalletBox';

interface INavBarProps {
  showMenu: boolean;
  closeMenu: () => void;
}

export default function CategoriesNav(props: Readonly<INavBarProps>) {
  const { customerInfo } = useContext(CustomerInfoContext);
  const { t: translate } = useTranslation();
  const navRef = useRef(null);
  const htmlElement = document.getElementsByTagName('html')[0];

  const { showMenu, closeMenu } = props;
  const { isTablet, isMobile } = useBreakpoints();
  const [isWalletVisible, setIsWalletVisible] = useState(false);

  const expandMenu = () => {
    htmlElement.classList.remove('collapsed-nav-mobile');
    htmlElement.classList.add('expanded-nav-mobile');
    htmlElement.classList.add('nav-translate');
    setTimeout(() => htmlElement.classList.remove('nav-translate'), 200);
  };

  const collapseMenu = () => {
    setIsWalletVisible(false);
    htmlElement.classList.remove('expanded-nav-mobile');
    htmlElement.classList.add('collapsed-nav-mobile');
    htmlElement.classList.add('nav-translate');
    setTimeout(() => htmlElement.classList.remove('nav-translate'), 200);
  };

  const removeMobileMenu = () => {
    closeMenu();
    htmlElement.classList.remove('collapsed-nav-mobile');
    htmlElement.classList.remove('expanded-nav-mobile');
  };

  useEffect(() => {
    if (isTablet) {
      if (showMenu) {
        expandMenu();
      } else {
        collapseMenu();
      }
    }
  }, [showMenu]);

  useEffect(() => {
    if (!isTablet) removeMobileMenu();
  }, [isTablet]);

  return (
    <div className="nav-bar" ref={navRef}>
      <div className="container">
        {/* Mobile header */}
        {isMobile && (
          <div className="mobile-nav-head">
            <a className="mobile-nav-close" onClick={closeMenu}>
              <Icons.CloseDelete />
            </a>
          </div>
        )}

        <CategoriesNavArea onCloseMenu={closeMenu} />

        {/* Admin button and wallet */}
        {!isTablet ? (
          <div>
            {customerInfo.isPowerUser && (
              <Link to="/admin/general-statistics" className="admin-nav-item">
                <span>{translate(resources.menu.admin)}</span>
              </Link>
            )}
            {customerInfo.showWallet && (
              <WalletBox
                isVisible={isWalletVisible}
                setIsVisible={setIsWalletVisible}
              />
            )}
          </div>
        ) : ( 
          customerInfo.showWallet && (
            <WalletBox
              isVisible={isWalletVisible}
              setIsVisible={setIsWalletVisible}
            />
          )
        )}

        {/* Mobile User Menu */}
        {isTablet && (
          <ul className="mobile-user-nav">
            {customerInfo.isPowerUser && (
              <li>
                <Admin isTablet={isTablet} closeMenu={closeMenu} />
              </li>
            )}
            <li>
              <Account isTablet={isTablet} closeMenu={closeMenu} />
            </li>
            <li onClick={() => closeMenu()}>
              <Help />
            </li>
            <li onClick={() => closeMenu()}>
              <Favorite />
            </li>
            <li onClick={() => closeMenu()}>
              <Link to="/cart" className="btn app-bar-tools-btn app-bar-cart">
                <span className="btn-icon cart-count">
                  <Icons.ShoppingCart />
                  {customerInfo.cartItemsCount > 0 && (
                    <span>{customerInfo.cartItemsCount}</span>
                  )}
                </span>
                <span className="btn-text">
                  {translate(resources.menu.cart)}
                </span>
              </Link>
            </li>
            <li>
              <Language />
            </li>
          </ul>
        )}
      </div>
    </div>
  );
}
